
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals",
      function () {
        return require("private-next-pages/festivals/index.tsx");
      }
    ]);
  